var render, staticRenderFns
import script from "./FlowNode.vue?vue&type=script&lang=js"
export * from "./FlowNode.vue?vue&type=script&lang=js"
import style0 from "./FlowNode.vue?vue&type=style&index=0&id=1186e524&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1186e524",
  null
  
)

export default component.exports